// src/components/SuccessPage.js
import React from 'react';

const SuccessPage = () => {
    return (
        <div className="w-full flex flex-col items-center justify-center p-6">
            <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                <svg className="w-16 h-16 text-green-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <h1 className="text-2xl font-bold mb-2">Parabéns!</h1>
                <p className="text-gray-700 mb-4">Sua solicitação foi enviada com sucesso.</p>
                <button
                    onClick={() => window.location.reload()}
                    className="mt-4 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
                >
                    Voltar
                </button>
            </div>
        </div>
    );
};

export default SuccessPage;
